// ============================================================
// Mora - Utility Functions
// ============================================================

/**
 * Merge class names, filtering out falsy values.
 * A lightweight alternative to clsx/classnames.
 * @param  {...string} classes - Class names to merge.
 * @returns {string} Merged class string.
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Framer Motion animation variants for scroll reveals.
 * Tuned with ultra-smooth cubic-bezier curves for fluid luxury deceleration.
 */
export const smoothEase = [0.16, 1, 0.3, 1];

export const fadeUpVariant = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: smoothEase },
  },
};

export const fadeInVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.7, ease: smoothEase },
  },
};

export const slideLeftVariant = {
  hidden: { opacity: 0, x: -24 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.75, ease: smoothEase },
  },
};

export const slideRightVariant = {
  hidden: { opacity: 0, x: 24 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.75, ease: smoothEase },
  },
};

export const scaleVariant = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.7, ease: smoothEase },
  },
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: smoothEase },
  },
};

